import { RecaptchaLibToken } from '../types/types';

/**
 * renderV2()
 */
export default (
  v2SiteKey: string,
  ref: React.RefObject<HTMLDivElement | null>,
  callback: (token: RecaptchaLibToken) => void,
  expiredCallback: () => void,
  errorCallback: () => void,
): number => {
  // Strategy: Try regular render first (preferred, the original way of doing things with this older recaptcha method), fallback to enterprise only if regular is not available
  const render = window.grecaptcha?.render ?? window.grecaptcha?.enterprise?.render;

  if (!render) {
    // Neither API available - this shouldn't happen if script loaded correctly
    throw new Error('No reCAPTCHA render method available (neither regular nor enterprise)');
  }

  const widgetId = render(ref.current ?? 'unknown', {
    sitekey: v2SiteKey,
    callback,
    'expired-callback': expiredCallback,
    'error-callback': errorCallback,
  });

  return widgetId;
};
